export default __webpack_public_path__ + "bca685733114631126cc59d205213876.png";